import { Severity } from '@wix/ambassador-ecom-v1-checkout/types';
import { hasSubdivisionShippingError, hasSubdivisionTaxError, hasZipCodeShippingError, hasZipCodeTaxError } from './calculationError.utils';
import { getShippingMethods } from './getShippingMethods';
import { hasShippableItems } from './hasShippableItems';
import { getFastFlowRedirectionReason } from './bi.util';
export async function shouldNavigateToFastFlowCheckout(_ref) {
  var _checkoutSettings$ter, _checkout$payNowTotal, _checkout$violations, _getShippingMethods;
  let {
    checkout,
    prevTotalAmount,
    shouldUpdateShippingAddress,
    checkoutSettings,
    checkoutService,
    needsShippingMethodSelection,
    biService,
    useSingleCustomerDetailsFormWithComposer
  } = _ref;
  const getHasCustomField = async () => {
    var _checkoutSettings$che;
    const checkoutComposerEnabled = await checkoutService.isCheckoutComposerEnabled();
    if (checkoutComposerEnabled) {
      const shouldNavigateToFastFlowDueToExtendedFieldsOrAdditionalInfo = useSingleCustomerDetailsFormWithComposer ? (await checkoutService.doesFormHaveRequiredDataExtendedFields()) || (await checkoutService.doesFormHaveRequiredAdditionalInfoField()) : !(await checkoutService.isExtendedFieldsFormEmpty());
      return shouldNavigateToFastFlowDueToExtendedFieldsOrAdditionalInfo;
    }
    return ((_checkoutSettings$che = checkoutSettings.checkoutCustomField) == null ? void 0 : _checkoutSettings$che.show) && checkoutSettings.checkoutCustomField.mandatory;
  };
  const hasTermsAndConditions = (_checkoutSettings$ter = checkoutSettings.termsAndConditions) == null ? void 0 : _checkoutSettings$ter.enabled;
  const hasCustomField = await getHasCustomField();
  const hasTaxZipCodeError = hasZipCodeTaxError(checkout);
  const hasTaxSubdivisionError = hasSubdivisionTaxError(checkout);
  const hasShippingZipCodeError = hasZipCodeShippingError(checkout);
  const hasShippingSubdivisionError = hasSubdivisionShippingError(checkout);
  const hasTotalAmountMismatchWithLatestSeen = prevTotalAmount !== ((_checkout$payNowTotal = checkout.payNowTotalAfterGiftCard) == null ? void 0 : _checkout$payNowTotal.amount);
  const hasViolations = (_checkout$violations = checkout.violations) == null ? void 0 : _checkout$violations.some(violation => violation.severity === Severity.ERROR || violation.severity === Severity.WARNING);
  const shouldChooseShippingMethod = shouldUpdateShippingAddress && hasShippableItems(checkout) && needsShippingMethodSelection && ((_getShippingMethods = getShippingMethods(checkout, {})) == null ? void 0 : _getShippingMethods.length) !== 1;
  const shouldNavigateToFastFlow = shouldChooseShippingMethod || hasTermsAndConditions || hasCustomField || hasTaxZipCodeError || hasTaxSubdivisionError || hasShippingZipCodeError || hasShippingSubdivisionError || hasTotalAmountMismatchWithLatestSeen || hasViolations;
  if (shouldNavigateToFastFlow) {
    var _checkout$cartId, _checkout$purchaseFlo;
    biService.reportNavigateToFastFlowCheckout({
      checkoutId: checkout.id,
      cartId: (_checkout$cartId = checkout.cartId) != null ? _checkout$cartId : undefined,
      purchaseFlowId: (_checkout$purchaseFlo = checkout.purchaseFlowId) != null ? _checkout$purchaseFlo : undefined,
      reason: getFastFlowRedirectionReason({
        shouldChooseShippingMethod,
        hasTermsAndConditions: Boolean(hasTermsAndConditions),
        hasCustomField: Boolean(hasCustomField),
        hasTaxZipCodeError,
        hasTaxSubdivisionError,
        hasShippingZipCodeError,
        hasShippingSubdivisionError,
        hasTotalAmountMismatchWithLatestSeen,
        hasViolations: Boolean(hasViolations)
      })
    });
  }
  return shouldNavigateToFastFlow;
}
//# sourceMappingURL=shouldNavigateToFastFlow.js.map